import RebortChat from 'assets/img/AvatarPlaceholder.svg';
import RebortInterface from 'assets/img/AvatarPlaceholder.svg';
import User from 'assets/img/user.png';

export const API_URL = process.env.REACT_APP_BASE_URL;
export const S3_BUCKET_URL = 'https://my-project-name-here.s3.us-east-1.amazonaws.com/images';
export const successType = ['data', 'status', 'success'];
export const errorType = ['data', 'error', 'message'];
export const FREE_PLAN_LOOKUP = 'chatbuddy-free-plan';
export const BUSINESS_PLAN_LOOKUP = 'chatbuddy-business-plan';

export const CHAT_BOT = {
  BOT: 'bot',
  USER: 'user',
  BOT_IMAGE: RebortChat,
};

export const CHAT_INTERFACE = {
  THEME_OPTION: [
    {
      value: '#FFFFFF',
      label: 'light',
    },
    {
      value: '#000000',
      label: 'dark',
    },
  ],
  CHAT_BUBBLE_ALIGNMENT_OPTIONS: [
    {
      value: 'right',
      label: 'right',
    },
    {
      value: 'left',
      label: 'left',
    },
  ],
  BOT_IMAGE: RebortInterface,
  USER_IMAGE: User,
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING',
  CONSUMED: 'CONSUMED'
};
